module.exports = __webpack_public_path__ + "static/media/flag-english.4f63f504.svg";